import edit_button from '../edit_button.html';

export default function (nga, admin) {
    var channelstreamsource = admin.getEntity('ChannelStreamSources');

    channelstreamsource.listView()
        .title('<h4>Channel Stream Sources <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>')
        .batchActions([])
        .fields([
            nga.field('stream_source', 'string')
                .label('Stream Source'),
            nga.field('startup_channel', 'reference')
                .targetEntity(admin.getEntity('Channels'))
                .targetField(nga.field('title'))
                .isDetailLink(true)
                .label('Startup Channel'),
        ])
        .filters([
            nga.field('q')
            .label('')
            .template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search" class="form-control"><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>')
            .pinned(true),
          ])      
        .listActions(['edit', '<a class="btn btn-default btn-xs" href="/admin/#/ChannelStreamSourcesClone/edit/{{entry.values.id}}"><span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span>&nbsp;Clone</a>', 'delete'])
        .exportFields([
            channelstreamsource.listView().fields(),
        ]);
        
    channelstreamsource.creationView()
        .title('<h4>Channel Stream Sources <i class="fa fa-angle-right" aria-hidden="true"></i> Create: Channel Stream Source</h4>')
        .fields([
            nga.field('stream_source', 'string')
                .attributes({ placeholder: 'Stream Source Name' })
                .validation({ required: true })
                .label('Stream Source'),
            nga.field('base_ip_address', 'string')
                .attributes({ placeholder: 'Ex: 10.10.xxx.x' })
                .label('Base IP Address'),
            nga.field('media_root_path', 'string')
                .attributes({ placeholder: 'Ex: /var/www/media/' })
                .label('Forensic Watermark Path'),
            nga.field('startup_channel', 'reference')
                .targetEntity(admin.getEntity('Channels'))
                .targetField(nga.field('title'))
                .remoteComplete(true, {
                    refreshDelay: 300,
                    searchQuery: function(search) {
                        return {q: search};
                    }
                })
                .isDetailLink(false)
                .label('Startup Channel'),
            nga.field('template')
                .label('')
                .template(edit_button)
        ]);

    channelstreamsource.editionView()
        .title('<h4>Channel Stream Sources <i class="fa fa-angle-right" aria-hidden="true"></i> Edit: {{ entry.values.stream_source }}</h4>')
        .actions(['list'])
        .fields([
            channelstreamsource.creationView().fields(),
            nga.field('ChannelStreams', 'referenced_list')
                .label('Channels')
                .targetEntity(admin.getEntity('ChannelStreams'))
                .targetReferenceField('stream_source_id')
                .targetFields([
                    nga.field('channel_id', 'reference')
						.targetEntity(admin.getEntity('Channels'))
						.targetField(nga.field('channel_number'))
                        .label('Nr'),
                    nga.field('channel_id', 'reference')
                        .targetEntity(admin.getEntity('Channels'))
                        .targetField(nga.field('icon_url')
                        .template('<img src="{{ entry.values.icon_url }}" height="35" width="35" />'))
                        .cssClasses('hidden-xs')
                        .label('Icon'),
                    nga.field('channel_id' , 'reference')
                        .targetEntity(admin.getEntity('Channels'))
                        .targetField(nga.field('title'))
                        .label('Channel'),
                    nga.field('stream_source_id', 'reference')
                        .targetEntity(admin.getEntity('ChannelStreamSources'))
                        .targetField(nga.field('stream_source'))
                        .label('Stream Source'),
                    nga.field('stream_url', 'string')
                        .map(function truncate(value) {
                            if (!value) {
                                    return '';
                                }
                                    return value.length > 25 ? value.substr(0, 25) + '...' : value;
                                })
                        .label('Stream Url'),
                ])
                .listActions(['edit'])
                .perPage(1500),
        ]);

    return channelstreamsource;
}


// WEBPACK FOOTER //
// ./js/channelStreamSource/config.js